import { Product } from 'types/products';
import { BaseSparePart } from 'types/spare-part';

type Item = BaseSparePart | Product;

export const isItemInList = (item: Item, list: Item[]): boolean => {
  return list.some((x) => x.id == item.id);
};
